'use strict';

module.exports = function(dest, source, overwrite) {
  if (!source) return dest;
  for (var key in source) {
    if (!source.hasOwnProperty(key)) continue;
    if (dest.hasOwnProperty(key) && overwrite === false) continue;
    if (dest[key] !== source[key])
      dest[key] = source[key];
  }
  return dest;
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/util/extend.js
 ** module id = 8
 ** module chunks = 0
 **/